export default "__VITE_ASSET__5753f35e__"